import { addSeconds } from 'date-fns'

export function formatDuration(unixTime: number): string {
  const durationDate = addSeconds(new Date(0), unixTime)
  const hours = durationDate.getUTCHours()
  const minutes = durationDate.getUTCMinutes()
  const seconds = durationDate.getUTCSeconds()

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  } else {
    return `${minutes}:${String(seconds).padStart(2, '0')}`
  }
}
